import { ready } from '~/core'
import addEvents from '~/utils/addEvents'
ready('web-analytic-link', 'a[data-activity]', (link) => {

    const bindEvent = (currentLink, currentActivity) => {
        link.addEventListener('click', () => {
            logActivity(currentLink, currentActivity)
        })

    }

    const logActivity = (currentLink, currentActivity) => {
        var activityToLog = {
            ActivityType: currentActivity,
            ActivityTitle: currentActivity,
            ActivityValue: currentLink.href,
            ActivityURL: window.location.href,
            ActivityURLReferrer: document.referrer
        };
        var dataString = JSON.stringify(activityToLog);
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.open("POST", '/api/webanalytics/logactivity', true);
        xmlhttp.setRequestHeader("Content-type", "application/json");
        xmlhttp.send(dataString);
    }

    const activity = link.getAttribute('data-activity');
    if (activity) {
        switch (activity.toLowerCase()) {
            case 'externallinkclick':
                const linkHost = new URL(link.href).hostname;
                const currentHost = window.location.hostname;
                if (linkHost && linkHost !== currentHost) {
                    bindEvent(link, activity);
                }
                break;
            default:
                bindEvent(link, activity);
                break;

        }
    }
   

})